import React, { useContext } from "react";
import {
  Button,
  Container,
  H4,
  Img,
  Label,
  Span,
} from "../../Styles/Global.Styled";
import ProductLabels from "./ProductLabels";
import { css } from "styled-components";
import { CartContext } from "../../Context/CartContext";
import BinIcon from "../../Icons/BinIcon";
import ProductQuantity from "./ProductQuantity";

const productCntStyle = css`
  flex-direction: column;
  padding:.5vh 1vh;
  box-shadow:0 0 2px 2px grey;
  border-radius:12px;
`;
const imgSize = css`
  width: 7vh;
  height: 7vh;
  margin-right: 1vh;
  /* border:2px solid red; */
`;
const cntStyle = css`
  flex-direction: column;
  justify-content: space-between;
  /* border:2px solid red; */
  gap: 0.5vh;
  flex-grow: 1;
`;
const bttnStyle = css`
  align-self:flex-start;
`;
const justifyStyle = css`
  justify-content: space-between;
`;
const priceQuanCnt = css`
  justify-content: space-between;
  margin-top: 1vh;
`;
const errorStyle = css`
  color: red;
  font-size: 1vh;
`;
const productNameStyle = css`
  font-size: 1.75vh;
`;

const ProductSummary = ({ product, isManagable = true }) => {
  const { removeProduct } = useContext(CartContext);

  return (
    <Container $baseStyle={productCntStyle}>
      <Container>
        {/* Product img */}
        <Img $baseStyle={imgSize} src={product.imageURL} />
        <Container $baseStyle={cntStyle}>
          {/* Product name */}
          <Container $baseStyle={justifyStyle}>
            <H4 $baseStyle={productNameStyle}>{product.product_name} </H4>
            {isManagable && (
              <Button
                $baseStyle={bttnStyle}
                onClick={() => removeProduct(product._id)}
              >
                <BinIcon />
              </Button>
            )}
          </Container>
          {/* Product labels */}
          <ProductLabels product={product} />
        </Container>
      </Container>
      {/* Product quantity and price */}
      <Container $baseStyle={priceQuanCnt}>
        {isManagable ? (
          <ProductQuantity product={product} />
        ) : (
          <Label>
            Qty: {`${product.cartQuantity}`} @ {`£${product.price}`}
          </Label>
        )}
        <Label>£{(product.cartQuantity * product.price).toFixed(2)}</Label>
      </Container>

      {/* Quantity error */}
      {product.error && (
        <Span $baseStyle={errorStyle}>
          The quantity requested is not available
        </Span>
      )}
    </Container>
  );
};

export default ProductSummary;
